import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  card: {
    borderRadius: 20,
    padding: "12px 10px 20px 10px",
    backgroundColor: "#FFF",
    border: "2px solid #E5E5E5",
  },
  cardHdr: {
    alignItems: "center",
    justifyContent: "space-between",
    padding: "3px 10px 15px 10px",
    borderBottom: "1px solid #D4D4D4",
  },
  cardHdng: {
    fontFamily: "Inter",
    fontSize: 24,
    fontWeight: 700,
    color: "#000",
    margin: 0,
  },
  tablesParent: {
    marginTop: 22,
    marginInline: 10,
    display: "flex",
    overflow: "auto",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
    },
  },
  tableParent1: {
    width: "50%",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      borderBottom: "1px solid #E5E5E5",
    },
  },
  tableParent2: {
    width: "50%",
    borderInline: "1px solid #E5E5E5",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      borderInline: "none",
      borderBottom: "1px solid #E5E5E5",
    },
  },
  table: {
    "& thead": {
      "& tr th": {
        backgroundColor: "#F5F5F5",
        fontSize: 14,
        fontWeight: 700,
        color: "#000",
        fontFamily: "Inter",
        padding: "14px 12px",
      },
    },
    "& tbody": {
      "& tr td": {
        fontSize: 14,
        fontWeight: 400,
        color: "#000",
        fontFamily: "Inter",
        padding: "14px 12px",
        display: "flex",
        alignItems: "center",
      },
    },
  },
  tdAmount: {
    flex: 1,
    fontSize: 14,
    fontWeight: 400,
    color: "#00A991",
    fontFamily: "Inter",
    textAlign: "end",
  },
  paginationRow: {
    flexWrap: "wrap",
    "& .tableWidth": {
      width: "40%",
      [theme.fn.smallerThan("sm")]: {
        width: "100%",
      },
    },
  },
}));

export default useStyles;
